import { AdvertisingDisclosures } from '@/pageSections/HeroDebt/components/AdvertisingDisclosures'
import { Typography } from '../Contentful'

function EditorsNote({ cardTitleText, cardText }) {
  return (
    <div className="border border-solid border-gray-200 rounded border-t-blue-400 border-t-8 p-4 md:py-4 md:px-6 shadow-lg mb-10 md:mb-16">
      <div className="flex justify-between items-center gap-2">
        <Typography content={cardTitleText} />
        <AdvertisingDisclosures />
      </div>
      <Typography content={cardText} />
    </div>
  )
}

export { EditorsNote }
